import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "filter-newsroom-event__activeFilterZone" };
const _hoisted_2 = { class: "filter-newsroom-event__activeFilterZoneTextArea" };
const _hoisted_3 = { class: "filter-newsroom-event__activeFilterZoneText" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", {
    class: "filter-newsroom-event__emptyButton",
    "data-js-item": "js-filter-newsroom-event-buttonPlaceholder"
}, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "filter-newsroom-event__oneFilterButton",
        "data-js-itemId": "empty",
        "data-js-zoneId": "empty",
        "data-js-item": "js-filter-newsroom-event-oneFilterButton"
    }, "placeholder")
], -1 /* HOISTED */);
const _hoisted_5 = { class: "filter-newsroom-event__filterDelete" };
import { computed } from 'vue';
import ActiveZoneTopicButton from "./FilterActiveZoneTopicButton.vue";
import ActiveZoneDateButton from "./FilterActiveZoneDateButton.vue";
import { useI18n, useNewsFilter, useTopicsDropdown } from '../features';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilterActiveZone',
    setup(__props) {
        const { t } = useI18n();
        const { selectedTopics, dateRange, clearFilter, applyFilters } = useNewsFilter();
        const { unCheckItem, clearCheckboxes } = useTopicsDropdown();
        const shouldDisplayActiveZone = computed(() => {
            return (selectedTopics.value && selectedTopics.value?.length > 0) ||
                (dateRange.value && dateRange.value?.length > 0);
        });
        const resetFilter = () => {
            clearFilter();
            clearCheckboxes();
        };
        const removeTopic = (id) => {
            if (selectedTopics.value) {
                selectedTopics.value = selectedTopics.value.filter(t => t.id !== id);
                applyFilters();
                unCheckItem(id);
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([shouldDisplayActiveZone.value ? 'is-showFilter' : 'is-hideFilter', "filter-newsroom-event__activeFilterArea"]),
                "aria-expanded": "false"
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('filter_active_zone_title')) + ":", 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedTopics), (topic) => {
                            return (_openBlock(), _createBlock(ActiveZoneTopicButton, {
                                topic: topic,
                                "onUpdate:remove": removeTopic
                            }, null, 8 /* PROPS */, ["topic"]));
                        }), 256 /* UNKEYED_FRAGMENT */)),
                        _createVNode(ActiveZoneDateButton)
                    ]),
                    _hoisted_4
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                        onClick: resetFilter,
                        type: "button",
                        class: "filter-newsroom-event__filterDeleteButton"
                    }, _toDisplayString(_unref(t)('filter_active_zone_delete')), 1 /* TEXT */)
                ])
            ], 2 /* CLASS */));
        };
    }
});
